<template>
  <div>
    <mdb-row style="margin-bottom: -4rem;">
      <mdb-col md="3" class="card-div">
        <div class="title-style">
          Pagos
          <br />
          <div style="font-size: 16px; font-weight: lighter;; display: -webkit-box;">
            Pagos registrados: &nbsp;<span style="font-size:18px; font-weight:600">{{ totalOfElements }}</span>
          </div>
        </div>
      </mdb-col>
      <mdb-col md="7" class="card-div searchBar">
        <input class="input-style" type="text" name="buscador" id="search" v-model="search"
          placeholder="Buscar por No. de Solicitud, Tipo de tarjeta o Código de autorización." />
      </mdb-col>
      <mdb-col md="2" class="card-div">
        <!-- <div>
          <button class="btn buttonFilter" type="button" @click="showFilterUser = !showFilterUser">
            <img src="/img/icons/InoFiltrar.svg" alt="filtrar" />
          </button>
        </div> -->
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <b-table :items="dataList" :fields="columns" class="text-center" :responsive="true" :no-provider-paging="false"
        :show-empty="true"
        emptyText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda."
        emptyFilteredText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda.">

        <template #cell(paymentStatus)="data">
          <div v-if="data.item.paymentStatus == 'APPROVED'" class="text-left">Aprobado</div>
          <div v-else-if="data.item.paymentStatus == 'REJECTED'" class="text-left">Rechazado</div>
          <div v-else class="text-left">Pendiente</div>
        </template>

        <template #cell(createdAt)="data">
          {{ data.item.createdAt.split("T")[0] }}
        </template>

        <template #cell(total)="data">
          {{ toMoney(data.item.total) }}
        </template>

        <template #cell(cardType)="data">
          <div v-if="data.item.cardType == 'debit'">Debito</div>
          <div v-else>Crédito</div>
        </template>

      </b-table>
    </mdb-row>

    <Paginator stylePaginator="full" :currentPage="page" :totalRows="totalOfElements" :perPage="perPage"
      @changePage="changePage" @changePerPage="changePerPage" />

    <!-- <mdb-row>
      <table class="t1-table text-center">
        <tr>
          <th>No. de solicitud</th>
          <th class="text-left">Estatus del pago</th>
          <th>Fecha de pago</th>
          <th class="text-left">Total</th>
          <th class="text-left">Tipo de tarjeta</th>
          <th class="text-left">Código de autorización</th>
        </tr>
        <tr v-for="(item, index) in dataList" v-bind:key="index">
          <td class="text-center">{{ item.applicationNumber }}</td>
          <td v-if="item.paymentStatus == 'APPROVED'" class="text-left">Aprobado</td>
          <td v-else-if="item.paymentStatus == 'REJECTED'" class="text-left">Rechazado</td>
          <td v-else class="text-left">Pendiente</td>
          <td class="text-center">{{ item.createdAt.split('T')[0] }}</td>
          <td class="text-left">{{ toMoney(item.total) }}</td>
          <td class="text-left">{{ item.cardType }}</td>
          <td class="text-left">{{ item.authCode }}</td>
        </tr>
        <tr v-if="!dataList || dataList.length === 0">

          <td></td>
          <td></td>
          <td>No se ha(n) encontrado resultado(s) de pagos que coincida(n) con tu búsqueda.</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </mdb-row>-->
    <!--<mdb-row>
      <mdb-col></mdb-col>
      <mdb-col>
        <div class="selectdiv">
          <div>
            <nav style="position: absolute; right: 80%;">
              <ul class="t1-pagination">
                <li v-if="page != 1">
                  <a @click="page--">
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(90deg)" />
                  </a>
                </li>
                <li v-for="pageNumber in numberOfPages" :class="pageNumber === page ? 't1-pagination--active' : ''"
                  :key="pageNumber">
                  <a @click="page = pageNumber">{{ pageNumber }}</a>
                </li>

                <li v-if="page < pages.length" @click="page++">
                  <a>
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(270deg)" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div>
            <select name="pages" id="pages">
              <option value="1">Pag. 1</option>
              <option value="2">Pag. 2</option>
              <option value="3">Pag. 3</option>
            </select>
          </div>
        </div>
      </mdb-col>
    </mdb-row> -->
    <Loader v-show="isLoading" />
  </div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import Swal from "sweetalert2";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";
import Loader from "../../core/Loader";
import Paginator from "../../core/Paginator.vue"

export default {
  name: "Payments",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbCard,
    Btn,
    Popup,
    ValidationError,
    Loader,
    Paginator
  },
  data() {
    return {
      search: "",
      isLoading: false,
      totalOfElements: 0,
      numberOfPages: 0,
      dataList: [],
      showFilterUser: false,
      page: 1,
      perPage: 10,
      columns: [
        {
          label: 'No. de solicitud',
          key: 'applicationNumber',
          sort: false,
          class: 'text-center',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff",
            "border-top-left-radius": "5px",
            "border-bottom-left-radius": "5px"
          },
          tdClass: "tableCol-start",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Estatus del pago',
          key: 'paymentStatus',
          sort: false,
          class: 'text-left',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Fecha del pago',
          key: 'createdAt',
          sort: false,
          class: 'text-center',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Total',
          key: 'total',
          sort: false,
          class: 'text-left',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 2.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Tipo de tarjeta',
          key: 'cardType',
          sort: false,
          class: 'text-center',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 2.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Código de autorización',
          key: 'authCode',
          sort: false,
          class: 'text-center',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 2.5rem",
            "background-color": "#3a8a65",
            "color": "#fff",
            "border-top-right-radius": "5px",
            "border-bottom-right-radius": "5px"
          },
          tdClass: "tableCol-end",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getListOfPayments"]),
    changePage(value) {
      this.page = value
    },
    changePerPage(value) {
      this.perPage = value
    },
    async getPaymentsList() {
      try {
        //this.isLoading = true;
        const params = {
          pageSize: this.perPage,
          pageNumber: this.page - 1,
          search: this.search
        };
        const { data } = await this.getListOfPayments(params);

        if (data.status === 200) {
          this.numberOfPages = data.data.totalPages;
          this.totalOfElements = data.data.totalElements;
          this.dataList = data.data.content.sort(function (a, b) {
            var dateAux = a.createdAt.split("T")[0]
            let dateA = new Date(dateAux.split("-")[1] + "/" + dateAux.split("-")[2] + "/" + dateAux.split("-")[0])
            var dateAux2 = b.createdAt.split("T")[0]
            let dateB = new Date(dateAux2.split("-")[1] + "/" + dateAux2.split("-")[2] + "/" + dateAux2.split("-")[0])

            if (dateA < dateB) {
              return 1;
            }
            if (dateA > dateB) {
              return -1;
            }
            return 0;
          });
        } else {
          this.dataList = [];
          this.totalOfElements = 0;
        }
      }
      catch (error) {
        this.isLoading = false;
        if (error && error.response && error.response.status === 404) {
          this.dataList = [];
        } else {

          this.$notify.error({
            message: "Ha ocurrido un error, inténtalo más tarde.",
            position: "top right",
            timeOut: 15000
          });
        }
      }

    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / this.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    cleanDataTable() {
      this.totalOfElements = 0;
      this.page = 1;
      this.perPage = 10;
      this.pages = [];
      this.numberOfPages = 0;
      this.search = "";
      this.dataList = [];
    },
    toMoney(text) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });

      return formatter.format(text);
    },
  },
  async mounted() {
    this.cleanDataTable();
    await this.getPaymentsList();
  },
  computed: {
    ...mapGetters({
      loginUserType: "getUserType",
    }),
    // displayedPost() {
    //   return this.paginate(this.dataList);
    // },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.getPaymentsList();
    },
    async page() {
      await this.getPaymentsList();
    },
    async perPage() {
      await this.getPaymentsList();
    }

  },
};
</script>

<style>
.tableCol {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

.tableCol-start {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

.tableCol-end {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

@media (min-width: 1024px) and (max-width: 1449px) {

  .table td {
    padding: 0.25rem;
  }

  .tableCol-start {
    padding-left: 30px !important;
    padding-right: 10px !important;
  }


  table.table-status {
    width: 100%;
  }

  table.table-status th {
    color: #dc7134;
    font-size: 1.8em;
  }

  table.table-status td {
    font-size: 1.6em;
  }
}
</style>